.EmberLoadingScreen {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
}
.EmberLoadingScreen .ProgressBar {
  width: 3em;
  height: 0.1em;
  overflow: hidden;
  border-radius: 0.1em;
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 0.25s;
  animation-delay: 0.25s;
  animation-fill-mode: forwards;
}
.EmberLoadingScreen .ProgressBar .Fill {
  width: 100%;
  height: 100%;
  border-radius: 0.1em;
  background-color: #f0ead6;
}
